import { DOT_RADIUS, DOT_RADIUS_SM } from '@aytm/app/stats/page/question-views/sh/components/shelf/lib/heatmapColors'
import MathHelpers from '@aytm/app/stats/lib/util/math'

export const renderDot = (svgEl, point, scale, gradientId) => {
  const cx = point.x
  const cy = point.y
  const r = DOT_RADIUS / scale
  const rsm = DOT_RADIUS_SM / scale
  const stroke = `url(#${gradientId})`

  let dotEl
  if (point.group != null) {
    dotEl = document.createElementNS('http://www.w3.org/2000/svg', 'g')
    dotEl.setAttribute('fill-rule', 'evenodd')
    dotEl.setAttribute('class', 'hm-dot')
    dotEl.dataset.group = point.group
    dotEl.dataset.cx = cx
    dotEl.dataset.cy = cy
    dotEl.setAttribute('style', `fill: #FF5511; stroke: ${stroke}; stroke-width: ${1 / scale};`)

    const pathOutside = `M ${cx} ${cy} m -${r}, 0 a ${r},${r} 0 1,1 ${r * 2},0 a ${r},${r} 0 1,1 -${r * 2},0`
    const pathInside = `M ${cx} ${cy} m -${rsm}, 0 a ${rsm},${rsm} 0 1,1 ${rsm * 2},0 a ${rsm},${rsm} 0 1,1 -${
      rsm * 2
    },0`

    const pathEl = document.createElementNS('http://www.w3.org/2000/svg', 'path')
    pathEl.setAttribute('d', `${pathOutside}${pathInside}`)
    dotEl.appendChild(pathEl)
  } else {
    dotEl = document.createElementNS('http://www.w3.org/2000/svg', 'circle')
    dotEl.setAttribute('cx', cx)
    dotEl.setAttribute('cy', cy)
    dotEl.dataset.cx = cx
    dotEl.dataset.cy = cy
    dotEl.setAttribute('r', r)
    dotEl.setAttribute('style', `fill: #FF5511; stroke: ${stroke}; stroke-width: ${1 / scale};`)
  }

  svgEl.appendChild(dotEl)
}

export const renderDots = (svgEl, { points, id, scale, gradientId }) => {
  if (!points?.length) return { commentsByGroups: {} }

  const withComments = points.filter(p => p.comment != null)
  const withoutComments = points.filter(p => p.comment == null)

  const groups = MathHelpers.calcPointsGroups(withComments, (DOT_RADIUS * 2) / scale)

  const commentsByGroups = {}

  withoutComments.forEach(point => renderDot(svgEl, point, scale, gradientId))

  groups.forEach((group, indexGroup) => {
    group.forEach(point => {
      if (!commentsByGroups[indexGroup]) {
        commentsByGroups[indexGroup] = []
      }

      commentsByGroups[indexGroup].push({
        text: point.comment,
        path: [id, point.batch.split('b')[1]],
        uid: point.uid
      })

      point.group = indexGroup
      renderDot(svgEl, point, scale, gradientId)
    })
  })

  return { commentsByGroups }
}
